import { useState } from "react";
import { FormConig , PageData } from "../interfaces/index";
import { ContactUsPage, ContactUsFields } from '../constants/index'
import {Header} from "../components/header/header";
import { Form} from "../components";

export const ContactUsForm = () => {
  const [inputAttributes, setFormConig] = useState<FormConig[]>(
    ContactUsFields
  );
  const [pageData, setPageData] = useState<PageData>(ContactUsPage);

  return (
    <div>
      <Header img={pageData.image} headerLabel={pageData.title} />
      <Form formHeaderText={pageData.header} inputAttributes={inputAttributes} />
    </div>
  );
}

